import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { Mesh, BufferGeometry } from 'three';
import { validateGeometry } from './GeometryValidator';
export async function loadHead(url: string) {
    const gltf = await new GLTFLoader().loadAsync(url);
    let head: Mesh | undefined;
    gltf.scene.traverse(o => { if ((o as Mesh).isMesh && !head)
        head = o as Mesh; });
    if (!head)
        throw Error('GLB не содержит геометрию');
    validateGeometry(head.geometry as BufferGeometry);
    head.name = 'CanonicalHeadMesh';
    return head;
}
